import { render, staticRenderFns } from "./logisaddpurchase.vue?vue&type=template&id=7bc7b6b4"
import script from "./logisaddpurchase.vue?vue&type=script&lang=js"
export * from "./logisaddpurchase.vue?vue&type=script&lang=js"
import style0 from "./logisaddpurchase.vue?vue&type=style&index=0&id=7bc7b6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports